export const Errors = {
  AUTH: {
    NOT_LOGIN: 1000
  },
  AJAX: {
    NETWORK_ERROR: 2001,
    RESPONSE_ERROR: 2002
  },
  COMMON: {
    UNKNOWN_ERROR: 9999,
    PROGRAM_ERROR: 1000
  }
}
